var map = {
	"./apple-laurel-da-DK.svg": 14274,
	"./apple-laurel-de-DE.svg": 78720,
	"./apple-laurel-en-GB.svg": 92098,
	"./apple-laurel-en-US.svg": 7049,
	"./apple-laurel-es-ES.svg": 87162,
	"./apple-laurel-es-MX.svg": 61849,
	"./apple-laurel-fr-FR.svg": 67482,
	"./apple-laurel-it-IT.svg": 77528,
	"./apple-laurel-nb-NO.svg": 26679,
	"./apple-laurel-nl-NL.svg": 37718,
	"./apple-laurel-pl-PL.svg": 99566,
	"./apple-laurel-pt-BR.svg": 35986,
	"./apple-laurel-pt-PT.svg": 39662,
	"./apple-laurel-sv-SE.svg": 66891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;